import { Box } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'
import { AnimatePresence } from 'framer-motion'

import SigningFeatureAcceptTermsBanner from 'modules/expenses/components/common/SigningFeatureAcceptTermsBanner'
import useLegalEntities from 'modules/expenses/hooks/useLegalEntities'
import {
  SignableOrganizationPerCountry,
  useTaxAgencyHomologations,
} from 'modules/expenses/hooks/useTaxAgencyHomologations'
import { useExpenses } from 'modules/expenses/pages/ExpensesContext'
import ProjectManagementUpsellProjectsBanner from 'modules/project_management/components/upsells/UpsellProjectsBanner'
import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'

const Banners = () => {
  const { data } = useExpenses()
  const { legalEntities } = useLegalEntities()

  const signedDocumentsTerms = data?.expenses?.signedDocumentsTerms ?? []
  const canCustomizeSettings = data?.expenses._policies.expenseCustomizeSettings?.can

  const hasTermsSigned = (organization: SignableOrganizationPerCountry) =>
    signedDocumentsTerms.some((t) => t.organization == organization) &&
    signedDocumentsTerms.some((t) => t.accepted)

  const {
    loading,
    enabled: homologationEnabled,
    organizations: { aeat, urssaf, ade },
  } = useTaxAgencyHomologations(legalEntities)

  if (loading) return null

  const pendingOrganizations = [aeat, urssaf, ade].filter(
    (org) => org.applies && !hasTermsSigned(org.id)
  )
  const showLegalComplianceBanner =
    homologationEnabled && canCustomizeSettings && pendingOrganizations.length > 0

  return (
    <AnimatePresence mode={'wait'}>
      <Box.Motion
        width="full"
        initial={{
          opacity: 0,
          height: 0,
        }}
        animate={{
          opacity: 1,
          height: 'auto',
        }}
        transition={{
          type: 'spring',
          duration: 0.5,
          delay: 1,
        }}
      >
        {!showLegalComplianceBanner && (
          <ProjectManagementUpsellProjectsBanner
            requestSource={ProjectsUpsellRequestSources.expenses}
            localStorageKey={LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideUpsellProjectsExpensesBanner}
          />
        )}
        {showLegalComplianceBanner && <SigningFeatureAcceptTermsBanner />}
      </Box.Motion>
    </AnimatePresence>
  )
}

export default Banners
